import { PACKS } from '@/mocks/chiliao';

export default function Packs() {
  return (
    <section id="packs" className="w-full scroll-mt-16 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-primary-500 pl-4 md:flex-row md:items-end md:justify-between md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-700">
              <i className="ri-archive-drawer-line text-sm" /> Ready to Go
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              精选打包 · 一键取整份
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            不用一篇篇挑。按主题提前归好档的合集包，一键看就整份展开，漏不了也重不了。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
          {PACKS.map((pack) => (
            <article
              key={pack.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100 transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-video w-full overflow-hidden">
                <img
                  src={pack.src}
                  alt={`51吃料 精选打包 · ${pack.name}`}
                  title={`51吃料 精选打包 · ${pack.name}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-fill text-sm" />
                  精选
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {pack.name}
                  </h3>
                  <span className="whitespace-nowrap text-xs font-medium text-foreground-500">
                    {pack.count}
                  </span>
                </div>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{pack.tagline}</p>

                <div className="mt-3 flex flex-wrap gap-2">
                  {pack.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <div className="mt-5">
                  <button
                    type="button"
                    className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    一键看整份
                    <i className="ri-arrow-right-up-line text-base" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}